module.exports = __webpack_public_path__ + "img/multiImages.e05f0cb5.svg";